export default __webpack_public_path__ + "static/media/menu_dashboard.7387d25e.svg";